import { Button as CtvButton } from '@accedo/ctv-button';
import { FunctionalComponent, Ref } from 'preact';
import { forwardRef } from 'preact/compat';

import { stylesheet } from 'astroturf';
import { BaseNav, Nav, NavProps, NavState } from '@accedo/spatial-nav';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .modal-outer-tag {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 99;
    top: 0;
  }

  .modal-content-box {
    width: pxToVw(366);
    height: pxToVh(270);
    margin: 20vh auto 0;
    text-align: center;
    background: transparent
      linear-gradient(180deg, rgb(24, 31, 38) 0%, rgb(6, 7, 9) 100%) 0% 0%
      no-repeat padding-box;
  }

  .modal-header {
    font-size: 2.75rem;
    padding: 5vh 0 1.5vh;
    font-family: barlow;
  }

  .modal-subtext {
    font-size: 1.6rem;
    padding: 1vh;
    font-family: barlow;
  }

  :global(.button).exit-button {
    display: block;
    font-family: barlowsemicondensed;
    font-size: pxToVh(18);
    width: pxToVw(244);
    padding: pxToVw(10) pxToVw(27) pxToVw(14);
    margin: pxToVh(15) auto 0;
    border-radius: pxToVw(80);
    background: rgb(0, 0, 6) 0% 0% no-repeat padding-box;
    border: 1px solid $pure-white;

    &:global(.current-focus) {
      background: linear-gradient(
          90deg,
          $ten-play-blue 0%,
          rgb(14, 163, 253) 100%
        )
        0% 0% no-repeat padding-box;
      border-color: transparent;
    }
  }
`;

interface ExitModalProps {
  navRef: Ref<BaseNav<NavProps, NavState>>;
  defaultFocusId: string;
  actions: {
    onExitModal: () => void;
    onExitApp: () => void;
  };
}

const ExitModalContent: FunctionalComponent<ExitModalProps> = ({
  navRef,
  defaultFocusId,
  actions,
}) => {
  const leaveButtonId = 'exit-modal-leave-button';
  const stayButtonId = 'exit-modal-stay-button';
  return (
    <div className={styles.modalOuterTag}>
      <Nav.Vertical id={defaultFocusId} ref={navRef}>
        <div className={styles.modalContentBox}>
          <div className={styles.modalHeader}>Are you not entertained?</div>
          <div className={styles.modalSubtext}>
            Just hit ‘Leave Now’ to exit 10.
          </div>
          <CtvButton
            className={styles.exitButton}
            navId={leaveButtonId}
            onClick={actions.onExitApp}
          >
            Leave Now
          </CtvButton>
          <CtvButton
            className={styles.exitButton}
            navId={stayButtonId}
            onClick={actions.onExitModal}
          >
            Keep Playing
          </CtvButton>
        </div>
      </Nav.Vertical>
    </div>
  );
};

export const ExitModalRef = forwardRef<BaseNav<NavProps, NavState>, ExitModalProps>(
  (props: ExitModalProps, ref: Ref<BaseNav<NavProps, NavState>>) => {
    const modalProps: ExitModalProps = {
      ...props,
      navRef: ref,
    };
    return <ExitModalContent {...modalProps} />;
  },
);
